module.exports = __webpack_public_path__ + "static/img/icon_anquan_hover.87d89811.svg";